/**
 * Class description
 *
 * Created: 2018-07-11
 * @author jonas
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power1, TimelineLite, TimelineMax, TweenLite} from "gsap"
import {DungeonQuestGameAssets} from "../../DungeonQuestGameAssets";

export class DungeonQuestLogo extends PIXI.Container {

    private _loop:TimelineLite | null;
    private _logo:PIXI.Sprite;
    private _shineMask:PIXI.Sprite;
    private _shine:PIXI.Sprite;
    private _placementContainer:PIXI.Container;
    private _spark:TimelineSprite;


    constructor(anchor:PIXI.Point = new PIXI.Point(0.5, 0.5)) {
        super();

        this._logo = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.INTRO_LOGO)[0]);
        this._shineMask = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.INTRO_LOGO_MASK)[0]);


        this._shine = new PIXI.Sprite(GameResources.getTextures(DungeonQuestGameAssets.INTRO_LOGO_SHINE)[0]);
        this._shine.anchor.set(0.5, 0.5);
        this._shine.position.set(-100, this._logo.height / 2);
        this._shine.rotation = -0.5;
        this._shine.mask = this._shineMask;
        this._shine.alpha = 0.5;

        this._spark = new TimelineSprite(GameResources.getTextures(DungeonQuestGameAssets.INTRO_LOGO_SPARK));
        this._spark.position.set(414, -17);
        this._spark.hide();

        this._placementContainer = new PIXI.Container();
        this._placementContainer.position.set(-this._logo.width * anchor.x, -this._logo.height * anchor.y);

        this._placementContainer.addChild(this._logo);
        this._placementContainer.addChild(this._shine);
        this._placementContainer.addChild(this._shineMask);
        this._placementContainer.addChild(this._spark);

        this.addChild(this._placementContainer);
    }

    public startLoop():void {
        this.stopLoop();
        this._loop = new TimelineMax({repeat : -1, repeatDelay : 8});
        this._loop.add(new TweenLite(this._shine.position, 1.2, {x : this._logo.width + 40, ease : Power1.easeIn}));
        this._loop.add(this._spark.getAnimationAutoShowHide(true, true), "-=0.1");

    }

    public stopLoop():void {
        if(this._loop) {
            this._loop.kill();
            this._loop = null;
        }
    }


}